/**
 * Re-export cn utility from @mdxui/primitives
 * This allows adapters to use consistent class merging
 */
export { cn } from '@mdxui/primitives/lib/utils'
